/** The portal's brand: name, wordmark, tab icon and home page. */
export type Brand = {
  id: 'mcpeer';
  name: string;
  /** Tab icon, under /public. */
  favicon: string;
  /** Shown under the wordmark in the sidebar. */
  tagline: string;
  /** The marketing site. */
  homeUrl: string;
};

export const brand: Brand = { id: 'mcpeer', name: 'MCPeer.ai', favicon: '/favicon-mcpeer.svg', tagline: 'PEERING FOR AGENTS', homeUrl: 'https://mcpeer.ai' };

/** Marks the document for the stylesheet and sets the tab title and icon. Called once at startup. */
export function applyBrand(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.brand = brand.id;
  document.title = `${brand.name} Portal`;
  const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (icon) icon.href = brand.favicon;
}
